// extracted by mini-css-extract-plugin
export default {"screenContainer":"ScreenContainer_screenContainer__+b2vG"};